import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Grid,
  TextField,
  MenuItem,
  Typography,
  Card,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker } from "@mui/x-date-pickers/DatePicker"; // Assuming you're using MUI X for DatePicker
import dayjs from "dayjs";
import axios from "axios";
import { POST_AUDIT_REMARK } from "../../constants";
import CloseIcon from "@mui/icons-material/Close";
import { DateTimePicker } from "@mui/x-date-pickers";

const AddRemarksDialog = ({
  open,
  setOpen,
  setSeverity,
  setMessage,
  setOpenSnackbar,
  setAlertTitle,
  setRunEffect,
}) => {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const storedLeadDetails = JSON.parse(localStorage.getItem("leadDetails"));

  const initialFormValues = {
    CH: "",
    AGE: "",
    BWT: "",
    M_QTY: "",
    REASON: "",
    MED: "",
    FEED: "",
    STOCK: "",
    IFFT_IN: "",
    IFFT_OUT: "",
    LS_VISIT: "",
    BM_VISIT: "",
    DAILY_ENT: "",
    FEED_ENT: "",
    MORT_ENT: "",
    BWT_ENT: "",
    MED_ENT: "",
    REMARKS: "",
    status: "",
    DATE: null,
    follow_up_date: null,
    Lot_Number: storedLeadDetails.Lot_Number,
    AgentId: empDetails.EmployeeId,
    followUpBy: "",
  };

  const [formValues, setFormValues] = useState({
    CH: "",
    AGE: "",
    BWT: "",
    M_QTY: "",
    REASON: "",
    MED: "",
    FEED: "",
    STOCK: "",
    IFFT_IN: "",
    IFFT_OUT: "",
    LS_VISIT: "",
    BM_VISIT: "",
    DAILY_ENT: "",
    FEED_ENT: "",
    MORT_ENT: "",
    BWT_ENT: "",
    MED_ENT: "",
    REMARKS: "",
    DATE: null,
    status: "",
    Lot_Number: storedLeadDetails.Lot_Number,
    AgentId: empDetails.EmployeeId,
    follow_up_date: null,
    type: "running",
    followUpBy: "",
  });

  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleDateChange = (newDate) => {
    setFormValues({
      ...formValues,
      follow_up_date: newDate,
    });
  };

  const validate = () => {
    const errors = {};

    // Always check for Remarks field
    if (!formValues.REMARKS) {
      errors.REMARKS = "Remarks is required";
    }

    // Only validate fields if status is "Open"
    if (formValues.status === "open") {
      // Uncomment or add validation rules as needed
      // if (!formValues.CH) errors.CH = 'Chicks Housed is required';
      // if (!formValues.AGE) errors.AGE = 'Mean Age is required';
      // if (!formValues.BWT) errors.BWT = 'Body Weight is required';
      // if (!formValues.M_QTY) errors.M_QTY = 'Mortality Quantity is required';
      // if (!formValues.REASON) errors.REASON = 'Reason is required';
      // if (!formValues.MED) errors.MED = 'Medicine is required';
      // if (!formValues.FEED) errors.FEED = 'Feed is required';
      // if (!formValues.STOCK) errors.STOCK = 'Stock is required';
      // if (!formValues.IFFT_IN) errors.IFFT_IN = 'IFFT In is required';
      // if (!formValues.IFFT_OUT) errors.IFFT_OUT = 'IFFT Out is required';
      // if (!formValues.LS_VISIT) errors.LS_VISIT = 'LS Visit is required';
      // if (!formValues.BM_VISIT) errors.BM_VISIT = 'BM Visit is required';
      // if (!formValues.DAILY_ENT) errors.DAILY_ENT = 'Daily Ent is required';
      // if (!formValues.FEED_ENT) errors.FEED_ENT = 'Feed Ent is required';
      // if (!formValues.MORT_ENT) errors.MORT_ENT = 'Mortality Ent is required';
      // if (!formValues.BWT_ENT) errors.BWT_ENT = 'BWT Ent is required';
      // if (!formValues.MED_ENT) errors.MED_ENT = 'Medicine Ent is required';
      // if (!formValues.DATE) errors.DATE = 'Date is required';

      if (!formValues.follow_up_date) {
        errors.follow_up_date = "FollowUp Date is required";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    // Call validate function to check for all errors, including Remarks
    if (!validate()) {
      return; // Stop submission if validation fails
    }

    // Proceed with submission logic if validation passes
    axios
      .post(POST_AUDIT_REMARK, formValues, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setSeverity("success");
        setAlertTitle(response.data.message);
        setOpenSnackbar(true);
        resetForm();
        setRunEffect(true);
        setOpen(false);
      })
      .catch((error) => {
        setSeverity("error");
        setAlertTitle(error.message);
        setOpenSnackbar(true);
        resetForm();
        setOpen(false);
      });
  };

  // To reset formValues to initial state
  const resetForm = () => {
    setFormValues(initialFormValues);
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setFormErrors({}); // Reset errors to empty object
      resetForm(); // Ensure a shallow copy is made
      setOpen(false);
    }
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => setOpen(false)}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          background: (theme) => theme.palette.primary.main,
          color: "#fff",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        Remark Form
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "#fff",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Chicks Housed"
                id="outlined-size-small"
                name="CH"
                value={formValues.CH}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
                error={!!formErrors.CH}
                helperText={formErrors.CH}
                size="small"
                fullWidth
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Mean Age"
                id="outlined-size-small"
                name="AGE"
                value={formValues.AGE}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
                error={!!formErrors.AGE}
                helperText={formErrors.AGE}
                size="small"
                fullWidth
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Body Weight"
                id="outlined-size-small"
                name="BWT"
                value={formValues.BWT}
                onChange={(e) => {
                  if (/^\d?(\.\d{0,3})?$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
                error={!!formErrors.BWT}
                helperText={formErrors.BWT}
                size="small"
                fullWidth
                inputProps={{
                  inputMode: "decimal",
                  pattern: "\\d?(\\.\\d{0,3})?",
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Mortality Quantity"
                id="outlined-size-small"
                name="M_QTY"
                value={formValues.M_QTY}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    handleChange(e);
                  }
                }}
                error={!!formErrors.M_QTY}
                helperText={formErrors.M_QTY}
                size="small"
                fullWidth
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Reason"
                id="outlined-size-small"
                name="REASON"
                value={formValues.REASON}
                onChange={handleChange}
                error={!!formErrors.REASON}
                helperText={formErrors.REASON}
                size="small"
                fullWidth
                sx={{
                  "& .MuiInputLabel-root": {
                    top: "0", // Adjust to align the label properly
                    "&.MuiInputLabel-shrink": {
                      top: "6px", // Ensure the label is fully visible when it shrinks
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Medicine"
                id="outlined-size-small"
                name="MED"
                value={formValues.MED}
                onChange={handleChange}
                error={!!formErrors.MED}
                helperText={formErrors.MED}
                size="small"
                fullWidth
                sx={{
                  "& .MuiInputLabel-root": {
                    top: "0", // Adjust to align the label properly
                    "&.MuiInputLabel-shrink": {
                      top: "6px", // Ensure the label is fully visible when it shrinks
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Feed"
                id="outlined-size-small"
                name="FEED"
                value={formValues.FEED}
                onChange={handleChange}
                error={!!formErrors.FEED}
                helperText={formErrors.FEED}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Stock"
                id="outlined-size-small"
                name="STOCK"
                value={formValues.STOCK}
                onChange={handleChange}
                error={!!formErrors.STOCK}
                helperText={formErrors.STOCK}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="IFFT In"
                id="outlined-size-small"
                name="IFFT_IN"
                value={formValues.IFFT_IN}
                onChange={handleChange}
                error={!!formErrors.IFFT_IN}
                helperText={formErrors.IFFT_IN}
                size="small"
                fullWidth
                sx={{
                  "& .MuiInputLabel-root": {
                    top: "0", // Adjust to align the label properly
                    "&.MuiInputLabel-shrink": {
                      top: "6px", // Ensure the label is fully visible when it shrinks
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="IFFT Out"
                id="outlined-size-small"
                name="IFFT_OUT"
                value={formValues.IFFT_OUT}
                onChange={handleChange}
                error={!!formErrors.IFFT_OUT}
                helperText={formErrors.IFFT_OUT}
                size="small"
                fullWidth
                sx={{
                  "& .MuiInputLabel-root": {
                    top: "0", // Adjust to align the label properly
                    "&.MuiInputLabel-shrink": {
                      top: "6px", // Ensure the label is fully visible when it shrinks
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="LS Visit"
                id="outlined-size-small"
                name="LS_VISIT"
                value={formValues.LS_VISIT}
                onChange={handleChange}
                error={!!formErrors.LS_VISIT}
                helperText={formErrors.LS_VISIT}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="BM Visit"
                id="outlined-size-small"
                name="BM_VISIT"
                value={formValues.BM_VISIT}
                onChange={handleChange}
                error={!!formErrors.BM_VISIT}
                helperText={formErrors.BM_VISIT}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Daily Ent"
                id="outlined-size-small"
                name="DAILY_ENT"
                value={formValues.DAILY_ENT}
                onChange={handleChange}
                error={!!formErrors.DAILY_ENT}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Feed Ent"
                id="outlined-size-small"
                name="FEED_ENT"
                value={formValues.FEED_ENT}
                onChange={handleChange}
                error={!!formErrors.FEED_ENT}
                helperText={formErrors.FEED_ENT}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Mortality Ent"
                id="outlined-size-small"
                name="MORT_ENT"
                value={formValues.MORT_ENT}
                onChange={handleChange}
                error={!!formErrors.MORT_ENT}
                helperText={formErrors.MORT_ENT}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="BWT Ent"
                id="outlined-size-small"
                name="BWT_ENT"
                value={formValues.BWT_ENT}
                onChange={handleChange}
                error={!!formErrors.BWT_ENT}
                helperText={formErrors.BWT_ENT}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Medicine Ent"
                id="outlined-size-small"
                name="MED_ENT"
                value={formValues.MED_ENT}
                onChange={handleChange}
                error={!!formErrors.MED_ENT}
                helperText={formErrors.MED_ENT}
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                id="outlined-select-currency"
                select
                label="Status"
                name="status"
                fullWidth
                value={formValues.status}
                onChange={handleChange}
                size="small"
                sx={{
                  "& .MuiFormHelperText-root": {
                    fontSize: "0.65rem",
                    marginLeft: "0",
                  },
                }}
              >
                <MenuItem
                  value={"open"}
                  sx={{
                    borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                    marginBottom: "8px",
                    marginTop: "8px",
                  }}
                >
                  Open
                </MenuItem>
                <MenuItem
                  value={"closed"}
                  sx={{
                    borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                    marginBottom: "8px",
                    marginTop: "8px",
                  }}
                >
                  Closed
                </MenuItem>
              </TextField>
            </Grid>

            {formValues.status === "open" && (
              <>
                <Grid item xs={12} md={6}>
                  <DateTimePicker
                    label="Follow Up Date and Time"
                    format="DD/MM/YYYY HH:mm"
                    sx={{ width: "100%" }}
                    value={
                      formValues.follow_up_date
                        ? dayjs(formValues.follow_up_date)
                        : null
                    }
                    onChange={(e) => {
                      const date = new Date(e.$d);
                      const year = date.getFullYear();
                      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero-indexed, so we add 1
                      const day = ("0" + date.getDate()).slice(-2);
                      const hours = ("0" + date.getHours()).slice(-2); // Add leading zero for hours
                      const minutes = ("0" + date.getMinutes()).slice(-2); // Add leading zero for minutes
                      const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
                      handleDateChange(formattedDateTime);
                    }}
                    slotProps={{
                      textField: {
                        error: !!formErrors.follow_up_date,
                        helperText: formErrors.follow_up_date,
                        required: true,
                        fullWidth: true,
                        size: "small",
                      },
                    }}
                    
                    shouldDisableDate={(date) => {
                      return dayjs(date).isSame(dayjs(), "day"); // Disable today's date
                    }}
                    disablePast
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Follow-Up By"
                    variant="outlined"
                    name="followUpBy"
                    value={formValues.followUpBy}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <TextField
                label="Remarks"
                id="outlined-size-small"
                name="REMARKS"
                multiline
                rows={4}
                value={formValues.REMARKS}
                onChange={handleChange}
                required
                error={!!formErrors.REMARKS}
                helperText={formErrors.REMARKS}
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        <Button
          onClick={() => {
            setOpen(false);
            setFormErrors("");
            setFormValues(initialFormValues);
          }}
          color="primary"
          variant="outlined"
          sx={{ borderRadius: "8px", width: "120px" }}
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          color="primary"
          variant="contained"
          sx={{ borderRadius: "8px", width: "120px" }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddRemarksDialog;
